import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { domain, apiKey, url },
} = checkout;

export default Yup.object().shape({
  [domain.name]: Yup.string().required(domain.errorMsg),
  [apiKey.name]: Yup.string().required(apiKey.errorMsg),
  [url.name]: Yup.string().required(url.errorMsg),
});
